module.exports = __webpack_public_path__ + "img/clock.6d673342.svg";